import { Audit } from '../interfaces/Audit';

export const getAuditTemplate = (): Audit => ({
  createdAt: new Date(),
  createdBy: 'admin',
});
